define(function () {
	'use strict';

	return function () {
		var _canvas = document.createElement('canvas'),
			_context = _canvas.getContext('2d'),
			_size = 18;

		_context.canvas.width = _size;
		_context.canvas.height = _size;

		_context.beginPath();
		_context.arc(_size / 2, _size / 2, (_size / 2) - 1, 0, 2 * Math.PI, false);
		_context.lineWidth = 2;
		_context.strokeStyle = '#9c9c9c';
		_context.fillStyle = '#9c9c9c';
		_context.stroke();
		_context.fill();
		_context.closePath();
		_context.fillStyle = '#ffffff';
		_context.font = 'bold 13px LatoLatin';
		_context.textAlign = 'center';
		_context.fillText('i', _size / 2, (_size / 2) + 5);


		// public methods

		this.get = function () {
			return _canvas;
		};
	}
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/canvas/InformationCanvas.js
// module id = 168
// module chunks = 1